<template>
  <v-dialog v-model="DIALOG_ATIVO_COMPUTED" persistent :width="largura" :content-class="contentClass" v-bind="$attrs">
    <template v-slot:activator="{ on, attrs }">
      <slot name="ativador" :callback="() => DIALOG_ATIVO_COMPUTED = ! DIALOG_ATIVO_COMPUTED"></slot>
    </template>

    <v-card>
      <v-card-title class="py-5">
        <slot name="titulo" :callback="() => DIALOG_ATIVO_COMPUTED = ! DIALOG_ATIVO_COMPUTED">
          <slot name="titulo.texto">
            <span v-text="titulo" />
          </slot>

          <v-spacer />

          <v-btn icon @click="DIALOG_ATIVO_COMPUTED = false;$emit('click:hidden-dialog', {})">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </slot>
      </v-card-title>

      <v-divider v-if="exibirDivisorTopo" class="mt-n2" />

      <v-card-text :class="{'pb-4': ocultarAcoes}">
        <slot>v-slot:default</slot>
      </v-card-text>

      <v-card-actions class="px-6 mt-n2" v-if="!ocultarAcoes">
        <v-spacer />

        <slot name="actions">
          <v-btn v-if="!ocultarBotaoSalvar" text :color="cor_do_botao" @click="$emit('click:primary', {})">
            {{txtBotao}}
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SysDialog',
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  emits: ["click:primary", "update:modelValue", "click:hidden-dialog"],
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    titulo: {
      type: [String, Number],
      default: "prop:titulo"
    },
    largura: {
      type: [String, Number],
      default: 600
    },
    txtBotao: {
      type: String,
      default: 'salvar'
    },
    cor_do_botao: {
      type: String,
      default: 'primary'
    },
    ocultarAcoes: {
      type: Boolean,
      default: false
    },
    ocultarBotaoSalvar: {
      type: Boolean,
      required: false
    },
    ocultar_botao_fechar: {
      type: Boolean,
      required: false
    },
    contentClass: {
      type: String,
      default: "bra-20"
    },
    exibirDivisorTopo: Boolean
  },
  computed: {
    DIALOG_ATIVO_COMPUTED: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit('update:modelValue', valor);
      }
    }
  }
}
</script>

<style scoped>

</style>
